<mat-form-field fxFlex="100"  appearance="outline"  [formGroup]="group">
    <mat-label>{{field.label}}
        <span *ngIf="isRequired(field.name)" class="required-symbol">*</span>
    </mat-label>
    <mat-select [placeholder]="field.label" [formControlName]="field.name">
        <mat-option *ngFor="let item of optionsList" [value]="item">{{item}}</mat-option>
    </mat-select>
    <mat-hint *ngFor="let validation of field['dynamicFormLabelValidator'];">{{validation.hintMessage}}</mat-hint>
</mat-form-field>